import React from 'react';

function RealizarOtraConsulta(props) {
  const { triggerNextStep, previousStep } = props;

  const setOptions = React.useCallback(async () => {
    const options = previousStep.value;

    triggerNextStep({ value: options, trigger: 'AnotherQueryButtons' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    setOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div>¿Requiere realizar otra consulta?</div>
    </>
  );
}

export default RealizarOtraConsulta;
